import type { AppConfig } from '@dvms/shared-types';

const REQUIRED_STRING_FIELDS = [
    'API_DOMAIN',
    'APP_ENV',
    'OKTA_ISSUER',
    'OKTA_CLIENT_ID',
    'OKTA_REDIRECT_URI',
    'OKTA_POST_LOGOUT_REDIRECT_URI',
] as const satisfies readonly (keyof AppConfig)[];

function assertAppConfig(json: unknown): asserts json is AppConfig {
    if (typeof json !== 'object' || json === null) {
        throw new Error('Config must be a JSON object');
    }

    const config = json as Record<string, unknown>;

    for (const field of REQUIRED_STRING_FIELDS) {
        if (typeof config[field] !== 'string') {
            throw new Error(`Config missing required field: ${field}`);
        }
    }
}

export function validateConfig(json: unknown): AppConfig {
    assertAppConfig(json);
    return json;
}
